import { render } from "./icons-ticket.svg?vue&type=template&id=5b94dd06?inline"
const script = {}
script.render = render

export default script